import { gql } from '@apollo/client';

const CommissionRuleFields = gql`
  fragment CommissionRuleFields on CommissionRuleType {
    id
    threshold
    minValue
    maxValue
    initialPercentage
  }
`;

export default CommissionRuleFields;
